<template>
  <div class="normal-layout-box show-flex-box-c">
    <div class="header-placehoder-box">
      <top-header></top-header>
    </div>
    <div class="view-box">
      <keep-alive>
        <router-view v-if="isKeepAlive"/>
      </keep-alive>
      <router-view v-if="!isKeepAlive" />
    </div>
    <div class="footer-content-box">
      <bottom-footer></bottom-footer>
    </div>
    <div class="login show-flex-box-r">
      <login ref="login"></login>
    </div>
    <div class="register show-flex-box-r">
      <register ref="register"></register>
    </div>
    <div class="find-password show-flex-box-r">
      <findPassword ref="findPassword"></findPassword>
    </div>
  </div>
</template>

<script>
import topHeader from "@/components/publick/header_cpn";
import bottomFooter from "@/components/publick/footer_cpn";
import login from "@/views/login/login";
import register from "@/views/login/register";
import findPassword from "@/views/login/find_password";
export default {
  name: "Layout",
  data() {
    return {
      isKeepAlive: false
    };
  },
  components: {
    topHeader,
    bottomFooter,
    login,
    register,
    findPassword
  },
  created() {
    this.isKeepAlive = this.$route.meta.keepAlive || false;
  },
  methods: {
    getHeaderClickInfo: function(clickHeaderInfo) {
      let clicktType = clickHeaderInfo.type;
      // alert(clicktType);
    }
    // CloseLoginpage: function(){
    //   this.$refs.login.colseLoginWin();
    // }
  },
  watch: {
    $route: function(from) {
      this.isKeepAlive = this.$route.meta.keepAlive || false;
    }
  }
};
</script>
<style lang="less" scoped>
.normal-layout-box {
  min-width: 100%;
  min-height: 100%;
  background: url("../../assets/common/page_publick_bg_1.png") center center
    no-repeat;
  background-size: 100% 100%;
  .header-placehoder-box {
    height: 56px;
    flex-shrink: 0;
    background: #302929;
  }
  .view-box {
    flex-grow: 1;
  }
  .footer-content-box {
    height: 84px;
    flex-shrink: 0;
    background: #f1f0ec;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue